import React from 'react';
import styles from '../../styles/scss/templates/industrial-page-new.module.scss';
import { supSub } from '../../services/util';

// datocms-assets.com supports imgix params; other hosts ignore the query string
const sizedSrc = (url, width) =>
    `${url}${url.includes('?') ? '&' : '?'}w=${width}&auto=format`

const buildSrcSet = (url) =>
    [640, 1024, 1440, 1920]
        .map((width) => `${sizedSrc(url, width)} ${width}w`)
        .join(', ')


const handleSmoothScroll = (e) => {
    const href = e.currentTarget.getAttribute('href');
    if (href && href.startsWith('#')) {
        e.preventDefault();
        const targetId = href.substring(1);
        const targetElement = document.getElementById(targetId);
        
        if (targetElement) {
            targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
            window.history.pushState(null, '', href);
        }
    }
};

const Hero = ({ heroSectionContent, breadcrumbs, heroCTAs, themeColor, pageSlug, heroStyles }) => {
    const hasMobileImage = heroSectionContent.heroMobile && heroSectionContent.heroMobile.url;
    const hasDesktopImage = heroSectionContent.heroDesktop && heroSectionContent.heroDesktop.url;
    
    const useImgixImages = hasMobileImage && hasDesktopImage;
    
    return (
        <div
            className={styles.hero}
            style={{
                backgroundImage: 'none'
            }}
        >
            {useImgixImages && (
                // one <picture> instead of two CSS-toggled <Imgix> images —
                // the browser downloads only the source matching its viewport
                <picture>
                    <source
                        media="(max-width: 479px)"
                        srcSet={buildSrcSet(heroSectionContent.heroMobile.url)}
                        sizes="100vw"
                    />
                    <img
                        src={sizedSrc(heroSectionContent.heroDesktop.url, 1440)}
                        srcSet={buildSrcSet(heroSectionContent.heroDesktop.url)}
                        sizes="100vw"
                        alt={heroSectionContent.title || 'Hero Image'}
                        fetchpriority="high"
                        className={styles.heroImage}
                    />
                </picture>
            )}
            <div className={styles.breadcrumbsContainer}>
                <div className={styles.breadcrumbsInner}>
                    <div className={styles.breadcrumbs}>
                        {breadcrumbs.map((breadcrumb, index) => (
                            <React.Fragment key={`breadcrumb-${index}`}>
                                {index > 0 && <span className={styles.breadcrumbSeparator}> &raquo; </span>}
                                {breadcrumb.url ? (
                                    <a href={breadcrumb.url} className={styles.breadcrumbLink} dangerouslySetInnerHTML={{ __html: supSub(breadcrumb.text) }} />
                                ) : (
                                    <span className={styles.breadcrumbCurrent} dangerouslySetInnerHTML={{ __html: supSub(breadcrumb.text) }} />
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                    <div className={styles.ctaButton}>
                        <a href={heroCTAs.topButton.url} className={styles.ctaLink} dangerouslySetInnerHTML={{ __html: supSub(heroCTAs.topButton.text) }} />
                    </div>
                </div>
            </div>
            
            <div className={styles.heroContent}>
                <p className={styles.heroEyebrow} style={heroStyles && heroStyles.eyebrowColor ? { color: heroStyles.eyebrowColor } : (themeColor !== "#DA291C" ? { color: themeColor } : null)} dangerouslySetInnerHTML={{ __html: supSub(heroSectionContent.eyebrow) }} />
                <h1 className={styles.heroTitle} style={heroStyles && heroStyles.titleColor ? { color: heroStyles.titleColor } : null} dangerouslySetInnerHTML={{ __html: supSub(heroSectionContent.title) }} />
                <p className={styles.heroBody} style={heroStyles && heroStyles.bodyColor ? { color: heroStyles.bodyColor } : null} dangerouslySetInnerHTML={{ __html: supSub(heroSectionContent.body) }} />
                <div className={styles.heroButtons}>
                    {heroCTAs.mainButtons.map((button, index) => (
                        <a 
                            key={`hero-button-${index}`} 
                            href={button.url} 
                            className={button.variant === 'outline' ? styles.outlineButton : styles.redButton}
                            style={button.variant === 'outline' 
                                ? { color: pageSlug === 'food-and-beverage' ? themeColor : '', borderColor: themeColor } 
                                : { backgroundColor: themeColor }}
                            onClick={handleSmoothScroll}
                        >
                            <span dangerouslySetInnerHTML={{ __html: supSub(button.text) }} />
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Hero;
